import {action, observable} from "mobx"

class SearchStore {

	@observable searchTerm = ""

	@observable list = []
	@observable byId = new Map()
	@observable deliveryAddress = false
	@observable invoiceAddress = false
	@observable baseAddress = false

	@action
	setSearchTerm(term) {
		this.searchTerm = term
	}

}

const searchStore = new SearchStore()
window["searchStore"] = searchStore
export default searchStore


// WEBPACK FOOTER //
// ./src/stores/searchStore.js